<div
  class="dialog-wrapper"
  (dragenter)="preventDrop($event)"
  (dragover)="preventDrop($event)"
  (drop)="preventDrop($event)">
  <div
    class="dialog-header"
    cdkDrag
    (cdkDragEnded)="onDragEnded($event)"
    cdkDragRootElement=".cdk-overlay-pane"
    cdkDragBoundary=".cdk-overlay-container"
    cdkDragHandle>
    <mat-icon class="drag-indicator">drag_indicator</mat-icon>
    <span class="dialog-title" [title]="data.title">{{ data.title }}</span>
    <button mat-icon-button (click)="closeDialog()" class="close-button">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <mat-dialog-content>
    <ng-container *ngComponentOutlet="data.component"></ng-container>
  </mat-dialog-content>

  @if (data.footer) {
    <footer class="sticky-modal-footer">
      <mat-dialog-actions align="end">
        <button mat-button mat-dialog-close>Avbryt</button>
        <button mat-button [mat-dialog-close]="true">
          {{ data.submitText }}
        </button>
      </mat-dialog-actions>
    </footer>
  }
</div>
